import * as types from '../../actions/actionTypes';

const defaultState = {
  data: null,
  // visibleSendMailModal: false
  mailSent: false,
};

export default (state = defaultState, action) => {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case types.SEND_EMAIL_CONTACT:
      return { ...state, mailSent: true };
    default:
      return nextState;
  }
};
